<template>
    <div>
        <div class="bg-white shadow mb-64 rounded-6  mx-auto relative pb-48 px-48 pt-16"
             :class="step === 3 ? 'max-w-1440' : 'max-w-1220'">

            <div class="flex justify-center mb-48 px-32">
                <steps v-model="step" :steps="steps" with-chevron />
            </div>


            <component :is="steps[step - 1].component"
                       :data="data"
                       :fieldOptions="fieldOptions"
                       :fields="fields"
                       :file="file"
                       :job_column="job_column"
                       :job_id="job_id"
                       :phase_column="phase_column"
                       :phase_id="phase_id"
                       :phases="phases"
                       :transformFields="transformFields"
                       @next="step++"
                       @previous="step--"
                       @removeFile="removeFile"
                       @setField="setField"
                       @setFile="setFile"
                       @setJob="setJob"
                       @setPhase="setPhase"
                       @setPhases="setPhases"
            />
        </div>
    </div>
</template>

<script>
import Steps from '../components/Steps';
import SelectFile from '../components/ui/import-tabs/SelectFile';
import ImportApplications from '../components/ui/import-tabs/ImportApplications';
import ImportJobs from '../components/ui/import-tabs/ImportJobs';
import ImportPhases from '../components/ui/import-tabs/ImportPhases';
import PapaParse from 'papaparse';
import ReviewImport from '../components/ui/import-tabs/ReviewImport';

export default {
    components: {ReviewImport, ImportPhases, ImportJobs, ImportApplications, SelectFile, Steps},
    data() {
        return {
            step: 1,

            // Step 1
            file: null,
            data: null,
            fields: null,

            // Step 2
            job_id: null,
            job_column: null, // TODO: HAS TO BE NULL, THIS IS FOR DEVELOPMENT PURPOSES

            // Step 3
            phase_id: null,
            phase_column: null, // TODO: HAS TO BE NULL, THIS IS FOR DEVELOPMENT PURPOSES
            phases: [],

            // Stop 4
            transformFields: {},
        };
    },
    computed: {
        steps() {
            return [
                {
                    title: this.$t('import.step_1.step'),
                    icon: 'file',
                    component: 'select-file',
                },
                {
                    title: this.$t('import.step_2.step'),
                    icon: 'format-list-bulleted',
                    disabled: this.step < 2,
                    component: 'import-jobs',
                },
                {
                    title: this.$t('import.step_3.step'),
                    icon: 'conversion-path',
                    disabled: this.step < 3,
                    component: 'import-phases',
                },
                {
                    title: this.$t('import.step_4.step'),
                    icon: 'assigment-ind',
                    disabled: this.step < 4,
                    component: 'import-applications',
                },
                {
                    title: this.$t('import.step_5.step'),
                    icon: '',
                    disabled: this.step < 4,
                    component: 'review-import',
                    hidden: true,
                },
            ];
        },
        fieldOptions() {
            if (!this.fields) {
                return [];
            }

            return this.fields.map(f => ({
                label: f,
                value: f,
            }));
        },
    },
    methods: {
        setFile(file) {
            this.file = file;

            PapaParse.parse(this.file, {
                header: true,
                skipEmptyLines: true,

                complete: ({data, meta}) => {
                    this.setData({data, fields: meta.fields});
                },
            });
        },
        removeFile(file) {
            this.file = null;
            this.data = null;
            this.fields = null;
        },
        setData({data, fields}) {
            this.data = data;
            this.fields = fields;
        },

        setJob({job_id, job_column}) {
            this.job_id = job_id;
            this.job_column = job_column;
        },

        setPhase({phase_id, phase_column}) {
            this.phase_id = phase_id;
            this.phase_column = phase_column;
        },
        setPhases(phases) {
            this.phases = phases;
        },

        setField({key, value}) {
            this.$set(this.transformFields, key, value);
        },
    },
};
</script>
